import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";

const StateMasterCharge = ({ classes, Charges, deleteCharges,value, setValue, minAmount, setMaxAmount, maxAmount, setMinAmount, setGstApplicable, gstApplicable, chargeDetials, setChargeDetails }) => {
    const [chargeNatureList] = useState([
        { code: "FLAT", name: "Flat" },
        { code: "PERCENTAGE", name: "Percentage" },
      ]);
  return (
    <div>
      <Grid container  className={classes.inputFieldContainer} style={{display:'flex', justifyContent:'space-between', marginTop:'15px'}}>
        <h2 className={classes.header}>Scheme Charges</h2>
        <Button
                className={`${classes.button2} ${classes.schemeButton}`}
                onClick={() => deleteCharges()}
                id="button"
              >
                Delete Charges
              </Button>
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer}>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Charges"
                required
                id="lp_Branch Charges"
                value={Charges || ""}
                disabled
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomSelectNew
                label="Charge Nature"
                value={chargeDetials}
                setState={setChargeDetails}
                id="lp_Branch Charge Nature"
                data={chargeNatureList}
                type="newSchemeCharge"
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
                label="Charge Type"
                required
                id="lp_Branch Charge Type"
                value={Charges || ""}
                disabled
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
                label="Value"
                required
                id="value"
                value={value || ""}
                setState={setValue}
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
                label="Min Amount"
                required
                id="Min Amount"
                value={chargeDetials === "FLAT" ? value : minAmount || '0'}
                setState={setMinAmount}
                disabled={chargeDetials === "FLAT"}
              />
            </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
                 label="max Amount"
                required
                id="max Amount"
                value={chargeDetials === "FLAT" ? value : maxAmount || '0'}
                setState={setMaxAmount}
                disabled={chargeDetials === "FLAT"}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <span style={{ fontWeight: "bold" }}>
              {" "}
              <input
                id="selectAll"
                type="checkbox"
                checked={gstApplicable}
                className={classes.checkboxInput}
                onChange={(e) => setGstApplicable(e.target.checked)}
              />{" "}
              GST Applicable
            </span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    
    </div>
  );
};

export default StateMasterCharge;
